import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import SendUsAMessage from "./sections/SendUsAMessage";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <SendUsAMessage />
      <ContactInformation />
      <Footer />
    </div>;
}